// extracted by mini-css-extract-plugin
export default {"select-item-style":"DnsdSelectContainer_select-item-style__4lKYi","low-opacity":"DnsdSelectContainer_low-opacity__ToNkl"};